import { apiGet } from '../utils/api'

//GET APIS
export const getOrganizationsAPI = () => {
  return apiGet('mgmt/organization')
}

export const getOrganizationViewsAPI = () => {
  return apiGet('mgmt/organization/views')
}



// WEBPACK FOOTER //
// ./src/api/organization.js